export default {
	title: "ORI Assistant",
	subtitle: "Get answers about the system",
	openLabel: "Open assistant",
	closeLabel: "Close",
	expandLabel: "Expand",
	collapseLabel: "Collapse",
	clearLabel: "Clear conversation",
	placeholder: "Type your question...",
	send: "Send",
	thinking: "Typing...",
	emptyTitle: "How can I help?",
	emptyHint: "Ask about records, rituals, finances, and more.",
	disclaimer:
		"AI-generated answers may contain errors. Double-check important information.",
	clearConfirm: "Clear the entire conversation?",
	errorGeneric: "I couldn't respond right now. Please try again.",
	errorUnavailable: "Assistant is currently unavailable.",
	suggestions: {
		s1: "How do I register a person?",
		s2: "How do I run the ticket call?",
		s3: "Where can I see the financial closing?",
	},
	guidedMode: {
		question: "How would you like to set up your temple?\n\n**Automatic**: I build each record and you just confirm it on the card.\n**Manual**: I guide you through the screens and you do it, learning the way.",
		automatic: "Automatic",
		manual: "Manual",
	},
	quickReplies: {
		label: "Answer options",
	},
	actions: {
		confirm: "Confirm",
		edit: "Edit",
		cancel: "Cancel",
		created: "Created successfully!",
		createError: "I couldn't create it. Please try again.",
		createErrorWithReason: "Couldn't create it: {reason}",
		checkOnScreen: "This record may already have been created. Check the screen before asking again.",
		noPermission: "You don't have permission for this.",
		continue: "Continue",
		continueMsg: "Done, created that one. Let's move to the next.",
	},
};
